import config from "@/config";
import { useUserInfoStore } from "@/store/userInfo";
import pinia from "@/store/pinia";

const userInfoStore = useUserInfoStore(pinia)

const log = (wx && wx.getRealtimeLogManager) ? wx.getRealtimeLogManager() : null


const getCommonParams = () => {
    return {
        v: config.version,
        userInfo: userInfoStore.userInfo,
    }
}

export default {
    info() {
        try {
            if (!log) return
            log.info.apply(log, [...arguments, getCommonParams()])
        } catch (e) {

        }
    },
    error() {
        try {
            if (!log) return
            log.error.apply(log, [...arguments, getCommonParams()])
        } catch (e) {

        }
    },
}
